export default "__VITE_ASSET__DZ0mM_Sw__"